// extracted by mini-css-extract-plugin
export var alignLeft = "F_qt d_fp d_bG d_dv";
export var alignCenter = "F_bP d_fq d_bD d_dw";
export var alignRight = "F_qv d_fr d_bH d_dx";
export var comparisonComponentContentEqual = "F_h9 d_h9 d_b1 d_w d_bz d_bF d_bJ d_w";
export var comparisonComponentEqual = "F_jc d_jc d_w d_y d_cX";
export var positioner = "F_sV";
export var wrapper = "F_sW d_c8";